import classNames from 'classnames';

import styles from './index.module.scss';

export const MonthOption = ({
  option,
  selectedMonth,
  setSelectedMonth,
  unit,
}) => {
  const clickHandler = () => {
    if (selectedMonth === option) {
      setSelectedMonth(null);
    } else {
      setSelectedMonth(option);
    }
  };
  return (
    <span
      onClick={clickHandler}
      className={classNames(styles.option, {
        [styles.option__active]: option === selectedMonth,
      })}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {option} {unit}
    </span>
  );
};
